<template>
  <div
    v-if="tabs.length === 1"
    :id="tabs[0].type"
    class="flex text-18 font-semibold lg:text-24 mt-2 lg:mt-8 lg:mb-3"
  >
    <img v-if="tabIcon" class="icon icon-md mr-3" :src="tabIcon" alt="" />
    {{ $t(`tabs.transfer_to_${activeTab}`) }}
  </div>
  <div
    v-else
    class="flex items-stretch overflow-x-auto pt-4 pb-2 mb-6 -mx-2 lg:px-2"
    role="tablist"
  >
    <Tab
      v-for="tab in tabs"
      :key="tab.type"
      @click="tabChanged"
      :tab="tab"
      :currency-to="currencyTo"
      :is-active="activeTab === tab.type"
      :is-expanded="tabs.length < 4 || activeTab === tab.type"
    />
  </div>
</template>

<script lang="ts" setup>
import Tab from './tab.vue'
import type { Tab as ITab } from '../types'
import type { PaymentType } from '@core/types/imt'

const props = defineProps<{
  tabs: ITab[]
  activeTab: PaymentType
  corridorAmount: number
  currencyFrom: string
  currencyTo: string
}>()

const router = useRouter()
const route = useRoute()

async function tabChanged(tab: string) {
  if (tab !== route.query.tab) {
    await router.push({ query: { ...route.query, tab: String(tab) } })
  }
}

const tabIcon = computed(() => getPaymentIcon(props.activeTab))
</script>
